import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, Button, Divider, Typography } from "@material-ui/core";
import { Add, Replay } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import StudentGuidanceInsertModal from "../StudentGuidanceInsertModal";

import {
  getAllStudentGuidance,
  getAllStudentGuidanceByProfileId,
  getFilteredStudentGuidance,
} from "../../../reducer/studentGuidance/action";

function StudentGuidanceButton(props) {
  const { getAllStudentGuidance, getAllStudentGuidanceByProfileId, getFilteredStudentGuidance } = props;

  const [inserting, setInserting] = useState(false);

  let profileId = props.selectedProfileId;
  if (!profileId) profileId = props.profileDetail?.id;

  useEffect(() => {
    if (props.type !== "all" && profileId) getAllStudentGuidanceByProfileId(profileId);
    return false;
  }, []);

  useEffect(() => {
    if (props.type === "all" && props.listFilteredStudentGuidance.length === 0 && !props.isFetching)
      getFilteredStudentGuidance(1, -1, { departmentId: props.department });
  }, []);

  useEffect(() => {
    if (props.type === "all" && !props.isFetching && !props.isFetchingAccepted)
      getFilteredStudentGuidance(1, -1, { departmentId: props.department });
  }, [props.department, getFilteredStudentGuidance]);

  const handleReload = () => {
    if (props.type !== "all") {
      if (profileId) {
        getAllStudentGuidanceByProfileId(profileId);
        props.handleReload();
      }
    } else {
      getFilteredStudentGuidance(1, -1, { departmentId: props.department });
      props.handleReload();
    }
  };
  const handleInsert = () => setInserting(true);

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h5" style={{ lineHeight: "36px" }}>
            Hướng dẫn NCKHSV/Đạt giải NCKH và tương đương
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <div style={{ float: "right" }}>
            <Button variant="outlined" startIcon={<Replay />} onClick={handleReload}>
              Tải lại
            </Button>
            {props.type !== "all" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                style={{ marginLeft: 8 }}
                onClick={handleInsert}
              >
                Thêm
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
      <Divider style={{ margin: "8px 0" }} />
      <StudentGuidanceInsertModal inserting={inserting} setInserting={setInserting} />
    </>
  );
}

const mapStateToProps = (state) => ({
  profileDetail: select(state, "profileReducer", "detail"),
  listStudentGuidanceById: select(state, "studentGuidanceReducer", "listById"),
  listFilteredStudentGuidance: select(state, "studentGuidanceReducer", "listFiltered"),
});

const mapDispatchToProps = (dispatch) => ({
  getAllStudentGuidanceByProfileId: (id) => dispatch(getAllStudentGuidanceByProfileId(id)),
  getFilteredStudentGuidance: (page, pageSize, payload) =>
    dispatch(getFilteredStudentGuidance(page, pageSize, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(StudentGuidanceButton));

